import { DTO } from './database';

const collection = 'settings';

class SettingsModel extends DTO {
  constructor(collection) {
    super(collection);
  }

  getServiceSettings(){
    return this.get('services');
  }

  updateServiceSettings(data) {
    return this.update('services', data);
  }
}

export const settingsModel = new SettingsModel(collection);
